import React, { useContext } from 'react'
import { GeneralContext } from '../context/'
import { Route, Redirect } from "react-router-dom"
import Loading from '../components/Loading'
import { useSelector } from 'react-redux'

const AppRoute = ({
	component: Component,
	layout: Layout,
	isAuthProtected,
    allowedRoles,
	...rest
}) => {
    const generalContext = useContext(GeneralContext)
	const {
		loading,
    } = generalContext

    const auth = useSelector((state) => state.Auth)

    const isAuthorized = () => {
        if (isAuthProtected && (!auth?.token || !auth?.profile)) return false

        if (!allowedRoles) return true

        return allowedRoles.includes(auth?.profile?.role?.codeName)
    }

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!isAuthorized()) {
                    return (
                        <Redirect
                            to={{
                                pathname: '/login',
                                state: { from: props.location }
                            }}
                        />
                    )
                }

                return (
                    <Layout>
                        <Component {...props} />
                        {loading && <Loading />}
                    </Layout>
                )
            }}
        />
    )
}

export default AppRoute
